import * as React from 'react';
import { FavoritesAssignWidgetContainer } from '@cian/favorites-assign-widget';
import { useDispatch, useSelector } from 'react-redux';
import { selectResults } from '../../selectors';
import { fetchFavoriteEntities } from '../../actions/favoriteEntities';
import { trackAddToCollection } from './tracking';
import { trackCreateFolder } from '../FoldersList/create/tracking';
import { FoldersNotification } from '../../components/FoldersNotification';
import { trackRemoveFromFolder } from '../MassActions/remove/tracking';
import { refreshFolders } from '../../thunk/favorites';

export function FoldersNotificationContainer() {
  const dispatch = useDispatch();
  const { favoriteEntities } = useSelector(selectResults);

  const handleSave = React.useCallback(
    (offerId: number) => {
      trackAddToCollection(favoriteEntities);
      dispatch(fetchFavoriteEntities({ offset: 0, limit: favoriteEntities.length }));
      dispatch(refreshFolders());
    },
    [favoriteEntities],
  );

  const handleCreate = React.useCallback(() => {
    trackCreateFolder(favoriteEntities);
    dispatch(refreshFolders());
  }, [dispatch]);

  const handleRemove = React.useCallback(() => {
    trackRemoveFromFolder(favoriteEntities);
    dispatch(refreshFolders());
  }, [dispatch]);

  return (
    <FoldersNotification>
      <FavoritesAssignWidgetContainer
        isAuthenticated={true}
        onCreateFolder={handleCreate}
        onSaveOffer={handleSave}
        onRemovedFromFolders={handleRemove}
      />
    </FoldersNotification>
  );
}
